var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78947 0H36.2105C38.0112 0 39.7381 0.716427 41.0114 1.99167C42.2847 3.26692 43 4.99653 43 6.8V27.2C43 29.0035 42.2847 30.7331 41.0114 32.0083C39.7381 33.2836 38.0112 34 36.2105 34H6.78947C4.98879 34 3.26186 33.2836 1.98859 32.0083C0.715318 30.7331 0 29.0035 0 27.2V6.8C0 4.99653 0.715318 3.26692 1.98859 1.99167C3.26186 0.716427 4.98879 0 6.78947 0ZM6.78947 2.26667C5.65789 2.26667 4.66211 2.652 3.89263 3.332L21.5 14.7333L39.1074 3.332C38.3379 2.652 37.3421 2.26667 36.2105 2.26667H6.78947ZM21.5 17.476L2.55737 5.168C2.37632 5.66667 2.26316 6.23333 2.26316 6.8V27.2C2.26316 28.4023 2.74004 29.5554 3.58888 30.4056C4.43773 31.2557 5.58902 31.7333 6.78947 31.7333H36.2105C37.411 31.7333 38.5623 31.2557 39.4111 30.4056C40.26 29.5554 40.7368 28.4023 40.7368 27.2V6.8C40.7368 6.23333 40.6237 5.66667 40.4426 5.168L21.5 17.476Z",
    fill: "url(#paint0_linear_86_281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_281",
    x1: 21.5,
    y1: 0,
    x2: 21.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#179EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E0CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIc);
export default __webpack_public_path__ + "static/media/email-ic.9bb903529cbce455994fa84dda8ef299.svg";
export { ForwardRef as ReactComponent };